export const FacilitiesSource = Object.freeze({
  publicAccountingProvider: 'PUBLIC_ACCOUNTING_PROVIDER',
  privateAccountingProvider: 'PRIVATE_ACCOUNTING_PROVIDER',
});

export const FacilitiesType = Object.freeze({
  creditLines: 'CREDIT_LINE',
  creditCards: 'CREDIT_CARD',
  bankAccounts: 'BANK_ACCOUNT',
  unknown: 'UNKNOWN',
});

export const FacilitiesLabels = Object.freeze({
  [FacilitiesType.creditLines]: 'Credit Lines',
  [FacilitiesType.creditCards]: 'Credit Cards',
  [FacilitiesType.bankAccounts]: 'Bank accounts',
});

// Singular
export const FacilitiesLabel = Object.freeze({
  [FacilitiesType.creditLines]: 'Credit Line',
  [FacilitiesType.creditCards]: 'Credit Card',
  [FacilitiesType.bankAccounts]: 'Bank account',
});
